module.exports = __webpack_public_path__ + "img/red-2-diamond-solid.843d23f6.svg";